/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// Libraries
import React from 'react';
import {
    object, shape, string, array, func, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { getPmallSummaryInfo } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { actions as tagManagerActions } from '../../../../../../../state/ducks/TagManager';

// UI Components
import ProductPlaImageUIMobile  from '../Partials/ProductPlaImageUIMobile';
import ProductImageUIMobileBlock from './Partials/ProductImageUIMobileBlock';
import useIsDisplayChannel from '../../../../../../helpers/hooks/useIsDisplayChannel';

const styles = (theme) => ({
    container: {
        display: 'flex',
        margin: '2px 0 5px 0',
    },
    img: {
        flexBasis: '50%',
    },
    retail: {
        color: theme.palette.error?.main,
        marginRight: '5px',
        textDecoration: 'line-through',
    },
    sale: {
        color: theme.palette.primaryButton,
        fontWeight: 'bold',
    },
    plaSlide: {
        alignSelf: 'center',
        width: '100%',
        height: 'auto',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        scrollBehavior: 'smooth',
    },
    plaSummaryContainer: {
        padding: '10px 10px 0',
        flexBasis: '50%',
        fontSize: '18px',
    },
    plaProdName: {
        margin: '0 0 10px',
        fontSize: '21px',
        fontWeight: '400',
    },
    plaDelivery: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        padding: '10px 0',
    },
    root: {
        position: 'relative',
        marginBottom: '5px',
        borderRadius: 0,
    },
    sliderContainer: {
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
        scrollSnapType: 'x mandatory',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    slide: {
        position: 'relative',
        paddingBottom: '109.3%',
        alignSelf: 'center',
        justifyContent: 'center',
        width: '100%',
        height: 'auto',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        scrollBehavior: 'smooth',
        display: 'flex',
    },
    productNameOverlayHeight: {
        marginBottom: '25px',
    },
    productNameContainer: {
        height: '25px',
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        color: 'white',
        fontWeight: '700',
        background: theme.palette.colorDisabled || '#ccc',
    },
    productName: {
        textAlign: 'center',
        [theme?.breakpoints?.down(1025)]: {
            display: 'none',
        },
        width: '90%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: '0 auto 5px auto',
    },
    sliderDotsContainer: {
        display: 'flex',
        margin: '7px 0 6px 0',
        justifyContent: 'center',
    },
    dotsActive: {
        marginRight: '10px',
        width: '10px',
        height: '10px',
        background: '#fff',
        borderRadius: '100%',
    },
    dotsInactive: {
        marginRight: '10px',
        width: '10px',
        height: '10px',
        background: 'rgba(255, 255, 255, .5)',
        borderRadius: '100%',
    },
    productNameforNormal: {
        textAlign: 'center',
        padding: '8px 0',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    productImageSliderContainer: {
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30px',
        color: 'white',
        fontWeight: '700',
        background: theme.palette.colorDisabled || '#ccc',
        opacity: '1',
    },
    imageContainer: {
        position: 'relative',
        '& img': {
            width: '100%',
            display: 'flex',
        },
    },
    snipe: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        right: 0,
        left: 0,
    },
    singleProduct: {
        display: 'none',
    },
    reviewCountContainer: {
        margin: '0 0 10px',
    },
    ratingStars: {
        margin: '0 17px 0 0',
        height: '19px',
        '& svg': {
            width: '20px',
            height: 'auto',
            color: theme.palette.cms?.ratingStarsColor || '#E4984B',
        },
    },
    reviewCount: {
        display: 'inline-block',
        color: theme.palette.cms?.reviewCountColor || '#B6B6B6',
        fontSize: '12px',
    },
    mainSliderContainer: {
        width: '100%',
    },
    carouselContainer: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        paddingBottom: '30px',
        '& .slick-list': {
            overflow: 'hidden',
        },
        '& .slick-slide': {
            display: 'table-cell',
            verticalAlign: 'middle',
            overflow: 'hidden',
            '&>div': {
                display: 'flex',
            },
        },
        '& .slick-dots': {
            margin: '0',
            display: 'flex !important',
            padding: '0',
            listStyle: 'none',
            justifyContent: 'center',
            position: 'absolute',
            width: '100%',
            height: '33px',
            bottom: '0',
            background: theme.palette.colorDisabled || '#ccc',
            opacity: '1',
            alignItems: 'center',
            '& li': {
                lineHeight: 1,
            },
            '& .slick-active': {
                '& div': {
                    background: theme.palette.cms?.white || '#fff',
                },
            },
            '& .slick-current': {
                '& div': {
                    paddingRight: 5,
                },
            },
        },
    },
    dotNavigation: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        cursor: 'pointer',
        display: 'inline-block',
        background: 'rgba(255, 255, 255, .5)',
        marginRight: 8,
    },
    productNameOnOverlay: {
        marginBottom: '30px',
        [theme?.breakpoints?.down(1025)]: {
            display: 'none',
        },
        '& $productNameContainer': {
            height: '30px',
        },
    },
    slickOverlay: {
        paddingBottom: '25px',
    },
    productImage: {
        '@media(hover: none)': {
            '& div[style*="opacity: 1"]:before': {
                display: 'block',
                position: 'absolute',
                content: '""',
                background: 'url("https://images.contentstack.io/v3/assets/blt95e0138311135214/bltd4026f47a9492630/630fcc337cb46356cd3a8cf2/close.png")',
                backgroundSize: 'cover',
                height: '30px',
                width: '30px',
                zIndex: '100',
                top: '5px',
                right: '5px',
            },
        },
    },
    pdpAltScrollBar: {
        '& [data-component="slideImageUi"]': {
            '& >div': {
                top: '-30px',
            },
        },
    },

    rootWrapper: {
        boxShadow: 'none',
        '& $productNameforNormal': {
            padding: '20px 16px 12px',
            fontSize: '28px',
            lineHeight: '36px',
            fontFamily: 'LatoBold',
            fontWeight: 'normal',
        },
        '& $carouselContainer': {
            paddingBottom: '0px',
            '& .slick-dots': {
                position: 'relative',
                opacity: 'unset',
                marginTop: '15px',
                background: 'transparent',
                '& .slick-active': {
                    '& div': {
                        background: '#000',
                    },
                },
            },
        },
        '& $dotNavigation': {
            width: 12,
            height: 12,
            marginRight: 12,
            border: '1px solid #000',
        },
        '& $pdpAltScrollBar': {
            '& [data-component="slideImageUi"]': {
                '& >div': {
                    top: '0',
                },
            },
        },
    },
});

const ProductImageUIMobile = ({
    classes,
    product = {},
    selectedSku = {},
    presentation_family,
    productNameDisplay,
    history,
    productName: itemName,
    pmallSummaryInfo,
    trackEvent,
    isPdpRedesignEnabled,
}) => {
    if (!product) {
        return null;
    }
    if (!selectedSku) {
        return null;
    }

    const productName = itemName || product.name;
    const snipeImagePath = product.image?.snipeImagePath;
    const snipe = product.image?.snipe;
    const deliveryMessage = product.availability.deliveryMessage;
    const productSkus = product.productSkus;
    const name = selectedSku.image?.name;
    const path = selectedSku.image?.path;
    const additionalImages = product.image?.additionalImages ? [...product.image.additionalImages] : [];

    // Checking functionality for test case
    const search = history?.entries?.[0]?.search?.includes('adtype=pla');
    const isDisplayChannel = useIsDisplayChannel();

    if (((typeof window !== 'undefined' && window?.location?.href.includes('adtype=pla')) || search || isDisplayChannel)) {
        return (
            <>
                <ProductPlaImageUIMobile
                    classes={classes}
                    name={name}
                    path={path}
                    additionalImages={additionalImages}
                    pmallSummaryInfo={pmallSummaryInfo}
                    productName={productName}
                    deliveryMessage={deliveryMessage}
                    productSkus={productSkus}
                    presentationFamily={presentation_family}
                />
            </>
        );
    }
    return (
        <>
            <ProductImageUIMobileBlock
                classes={classes}
                product={product}
                productName={productName}
                name={name}
                path={path}
                snipe={snipe}
                snipeImagePath={snipeImagePath}
                additionalImages={additionalImages}
                presentation_family={presentation_family}
                productNameDisplay={productNameDisplay}
                pmallSummaryInfo={pmallSummaryInfo}
                trackEvent={trackEvent}
                selectedSku={selectedSku}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});

const mapStateToProps = (state) => ({
    pmallSummaryInfo: getPmallSummaryInfo(state),
});

ProductImageUIMobile.propTypes = {
    classes: object.isRequired,
    product: shape({
        name: string.isRequired,
        image: shape({
            additionalImages: array.isRequired,
            snipeImagePath: string.isRequired,
            snipe: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
        }).isRequired,
    }).isRequired,
    selectedSku: shape({
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }),
    }).isRequired,
    presentation_family: string.isRequired,
    productNameDisplay: string.isRequired,
    history: object.isRequired,
    productName: string.isRequired,
    pmallSummaryInfo: shape({
        customizations: shape({
            refnum: string,
        }),
    }),
    trackEvent: func.isRequired,
    isPdpRedesignEnabled: bool,
};

ProductImageUIMobile.defaultProps = {
    pmallSummaryInfo: {},
    isPdpRedesignEnabled: false,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProductImageUIMobile)));
